import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';

const Layout = () => {
    return (
        <main style={{ fontFamily: 'Kode Mono' }} className="App">
            <NavigationBar />
            <h1 className='mt-5'></h1>
            <Outlet />
        </main>
    );
};

export default Layout;